var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"HomeTabsContent"}},[(_vm.activeTabName==='banner')?_c('Banner'):(_vm.activeTabName==='celebrities')?_c('Celebrities'):(_vm.activeTabName==='feeds')?_c('Feeds'):(_vm.activeTabName==='outstanding')?_c('Outstanding'):(_vm.activeTabName==='categories')?_c('Categories'):(_vm.activeTabName==='webstars')?_c('Webstars'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }